<!--
 * @Author: 牛字杰 niuzijie@.jtexpress
 * @Date: 2022-07-26 09:58:25
 * @LastEditors: niuzijie
 * @LastEditTime: 2024-07-17 20:20:14
 * @FilePath: \jmssa-vip-customers-front\src\views\problem-shipment\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="main-wrap problem">
    <div class="problem-top">
      <el-button type="primary" @click="handleExport" icon="iconfont icondaochu" :loading="exportLoading" class="h40 exportOpen" plain>{{ $t('导出') }}</el-button>
      <el-button type="primary" @click="dialogExportDownVisible = true" class="h40" plain>{{ $t('下载中心') }}</el-button>
      <el-button type="primary" @click="handleReply" :disabled="selectedRows.length === 0" class="h40">{{ $t('回复') }}</el-button>
      <el-button type="primary" v-if="false" @click="importOrder" icon="iconfont icondaochu" class="h40" plain>{{ $t('导入') }}</el-button>
      <el-button type="primary" v-if="false" @click="downloadTemplate(1)" icon="iconfont icondaochu" class="h40" plain>{{ $t('下载批量回复模板') }}</el-button>
      <div class="problem-topLeft" id="jmsSearch">
        <el-form :model="searchParam" ref="search" :inline="true" label-position="top">
          <el-form-item prop="date">
            <el-date-picker
              :clearable="false"
              v-model="searchParam.date"
              type="daterange"
              :default-time="['00:00:00', '23:59:59']"
              :range-separator="$t('至')"
              :start-placeholder="$t('开始日期')"
              :end-placeholder="$t('结束日期')"
              class="commonSize"
              :picker-options="pickerOptions"
              @change="selectDate"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </el-form-item>
          <el-form-item prop="waybillIds">
            <base-input-tag
              style="width: 210px"
              v-model="searchParam.waybillIds"
              :placeholder="$t('请输入运单编号(最多可查100条)')"
              :clearBtnVisible="true"
              :addTagOnBlur="true"
              ref="BaseInputTag1"
              class="cms-input-tag">
            </base-input-tag>
          </el-form-item>
          <el-form-item prop="processingStatus">
            <el-select clearable v-model="searchParam.processingStatus" :placeholder="$t('处理状态')">
              <el-option v-for="item in processingStatusList" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item prop="clientInstruct">
            <el-select clearable v-model="searchParam.clientInstruct" :placeholder="$t('客户指令')">
              <el-option v-for="item in clientInstructList" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item prop="problemType">
            <el-select clearable v-model="searchParam.problemType" :placeholder="$t('问题类型')">
              <el-option v-for="item in questionTypeList" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item prop="rejectionsNum">
            <el-input type="text" v-model="searchParam.rejectionsNum" maxlength="6" :placeholder="$t('拒收次数')" clearable/>
          </el-form-item>
          <el-form-item prop="replyTime">
            <el-input type="text" v-model="searchParam.replyTime" maxlength="6" :placeholder="$t('回复耗时')" clearable/>
          </el-form-item>
          <el-form-item prop="deliveryNum">
            <el-input type="text" v-model="searchParam.deliveryNum" maxlength="6" :placeholder="$t('派送次数')" clearable/>
          </el-form-item>
          <el-form-item prop="storageDays">
            <el-input type="text" v-model="searchParam.storageDays" maxlength="6" :placeholder="$t('仓储天数')" clearable/>
          </el-form-item>
          <el-form-item prop="dealType">
            <el-select clearable v-model="searchParam.dealType" :placeholder="$t('处理类型')">
              <el-option v-for="item in processTypeList" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="iconfont iconchaxun" class="h32" @click="searchChange">{{ $t('查询') }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" plain icon="iconfont iconshanchu" class="h32" @click="resetSearch">{{ $t('清空') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="table-container">
      <JmsTable
        :option="listOpt"
        :data="tableList"
        :page="page"
        :table-loading="loading"
        @row-del="rowDel"
        @size-change="sizeChange"
        @selection-change="selectionChange"
        @current-change="currentChange">
        <template slot="waybillNo" slot-scope="data">
          <div :class="{ 'errorData': data.row.waybillNoBgRed }">{{ data.row.waybillNo }}</div>
        </template>
      </JmsTable>
    </div>
    <!-- 下载中心 -->
    <export-download-dialog moduleType="vip_problem_handle" :dialogExportDownVisible.sync="dialogExportDownVisible"/>
    <!-- 回复 -->
    <the-reply-dialog :visible.sync="isShowReplyDialog" @success="handleReplySuccess" />
    <!-- 导入 -->
    <upload-dialog ref="uploadRef"/>
  </div>
</template>

<script>
import { fetchProblemAsyExport, fetchProblemPieceHandlingList } from '@/api/module/problemPiece.js'
import ExportDownloadDialog from '@/components/export-download-dialog/ExportDownloadDialog.vue'
import JmsTable from '@/components/jms-widget/jms-table/index.vue'
import mixin from '@/mixins/mixin.js'
import { DICT } from '@/utils/dict.js'
import { lang } from '@/utils/filters.js'
import { commonFun } from '@/utils/util.js'
import { mapGetters } from 'vuex'
import TheReplyDialog from './components/TheReplyDialog.vue'
import UploadDialog from './components/uploadDialog.vue'

export default {
  name: 'ProblemHandling',
  mixins: [mixin],
  components: {
    JmsTable,
    ExportDownloadDialog, // 下载中心
    TheReplyDialog, // 回复弹窗
    UploadDialog, // 导入
  },
  provide() {
    return {
      selectedRows: () => this.selectedRows
    }
  },
  data() {
    return {
      COM_HTTP: {
        reqList: fetchProblemPieceHandlingList,
        reqExcel: fetchProblemAsyExport
      },
      page: {
        // 分页配置
        current: 1,
        size: 500,
        total: 0,
        sizes: [
          50,
          100,
          200,
          500,
          1000,
        ],
      },
      dialogExportDownVisible: false, // 下载中心弹窗
      dialogImportVisible: false, // 导入弹窗
      dialogTemplateVisible: false, // 下载批量回复模板
      searchParam: {
        date: commonFun.GetTodayDate(), // commonFun.GetTodayDate(),
        startDate: commonFun.GetTodayDate()[0], // commonFun.GetTodayDate()[0],
        endDate: commonFun.GetTodayDate()[1], // commonFun.GetTodayDate()[1],
        waybillIds: [], // 运单号
        processingStatus: '', // 处理状态
        problemType: '', // 问题类型
        clientInstruct: '', // 客户指令
        rejectionsNum: '', // 拒收次数
        replyTime: '', // 回复耗时
        deliveryNum: '', // 派送次数
        storageDays: '', // 仓储天数
        dealType: '', // 处理类型
      },
      multipleSelection: [], // 多选或全选数据
      // 处理状态
      processingStatusList: [
        { label: lang('已处理'), value: 1 },
        { label: lang('待处理'), value: 2 },
        { label: lang('已完结'), value: 3 },
      ],
      // 问题类型
      questionTypeList: [
        { label: lang('地址错误'), value: 1 },
        { label: lang('电话错误'), value: 2 },
        { label: lang('拒收一次'), value: 3 },
        { label: lang('两次联系不上'), value: 4 },
      ],
      // 处理类型
      processTypeList: [
        { label: this.$lang('待客户处理'), value: 1 },
        { label: this.$lang('待退回'), value: 2 },
        { label: this.$lang('已退回'), value: 3 },
        { label: this.$lang('已预约派送'), value: 4 },
        { label: this.$lang('已派送'), value: 5 }
      ],
      clientInstructList: DICT.clientInstructList, // 客户指令
      exportColumnList: [], // 导出的列表字段
      excelParams: {}, // 导出日期条件
      exportLoading: false, // 导出按钮加载
      isShowReplyDialog: false, // 回复弹窗
    }
  },
  computed: {
    ...mapGetters(['user']),
    listOpt() {
      const that = this
      return {
        border: true,
        selection: true,
        menu: false,
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        // rowKey: '$index',
        fixHeight: 90,
        menuWidth: 150,
        //  搜索框和表格列及其字段
        column: [
          {
            label: '生成时间',
            prop: 'createTime',
          },
          {
            label: '运单号',
            prop: 'waybillNo',
            slot: true,
            width: 150,
            renderHeader: that.renderHeader
          },
          {
            label: '客户名称',
            prop: 'customerName',
          },
          {
            label: '处理状态',
            prop: 'dealStatusStr',
          },
          {
            label: '问题描述',
            prop: 'problemDesc',
          },
          {
            label: '问题类型',
            prop: 'problemTypeStr',
          },
          {
            label: '派送次数',
            prop: 'deliveryNum',
          },
          {
            label: '拒收次数',
            prop: 'refuseNum',
          },
          {
            label: '回复耗时',
            prop: 'replayUseDay',
          },
          {
            label: '仓储天数',
            prop: 'storageDay',
          },
          {
            label: '客户指令',
            prop: 'clientInstructStr',
          },
          {
            label: '客户备注',
            prop: 'clientRemark',
          },
          {
            label: '客服备注',
            prop: 'serviceRemark',
          },
          {
            label: '处理类型',
            prop: 'dealTypeStr',
          },
        ],
      }
    },
  },
  watch: {
    'searchParam.rejectionsNum'(newV, oldV) {
      this.searchParam.rejectionsNum = newV.replace(/[^\d]/g, '')
    },
    'searchParam.replyTime'(newV, oldV) {
      this.searchParam.replyTime = newV.replace(/[^\d]/g, '')
    },
    'searchParam.deliveryNum'(newV, oldV) {
      this.searchParam.deliveryNum = newV.replace(/[^\d]/g, '')
    },
    'searchParam.storageDays'(newV, oldV) {
      this.searchParam.storageDays = newV.replace(/[^\d]/g, '')
    },
    selectedRows(val) {
      this.selectedRow = val
    }
  },
  methods: {
    /**
     * 重写方法获取参数
     * @returns {{}}
     */
    getParams() {
      const { startDate, endDate, waybillIds, processingStatus, clientInstruct, problemType, rejectionsNum, replyTime, deliveryNum, storageDays, dealType } = this.searchParam
      return {
        startTime: waybillIds.length ? '' : startDate,
        endTime: waybillIds.length ? '' : endDate,
        waybillNos: waybillIds, // 运单号
        dealStatus: processingStatus, // 处理状态
        clientInstruct: clientInstruct, // 客户指令
        problemType: problemType, // 问题类型
        // 拒收次数
        refuseNumBegin: rejectionsNum,
        refuseNumEnd: rejectionsNum,
        // 回复耗时
        replayUseDayBegin: replyTime,
        replayUseDayEnd: replyTime,
        // 派送次数
        deliveryNumBegin: deliveryNum,
        deliveryNumEnd: deliveryNum,
        // 仓储天数
        storageDayBegin: storageDays,
        storageDayEnd: storageDays,
        countryId: this.user.countryCode === 'KSA' ? 1 : 2,
        dealType: dealType
      }
    },
    /**
     * 查询
     * @returns {Promise<ElMessageComponent>}
     */
    async searchChange() {
      try {
        const { waybillIds } = this.searchParam
        const space = 31 * 24 * 3600 * 1000
        const startDate = new Date(this.searchParam.startDate).getTime()
        const endDate = new Date(this.searchParam.endDate).getTime()
        if ((endDate - startDate) > space) {
          return this.$message.error(this.$t('开始时间与结束时间之差不能大于31天'))
        }

        // 处理运单编号
        if (waybillIds && waybillIds.length !== 0) {
          if (waybillIds.length > 100) {
            return this.$message.warning(this.$t('请勿超过100条运单'))
          }
        }
        // 列表查询
        await this.searchFun(1)
      } catch (e) {
        console.log(e)
      }
    },
    // 清空
    resetSearch() {
      this.$refs['search'].resetFields()
    },
    /**
     * 导入
     */
    importOrder() {
      this.$refs['uploadRef'].showDialog()
    },
    /**
     * 回复
     */
    handleReply() {
      if (this.selectedRows.length === 1 && (this.selectedRows[0].dealStatus === 1 || this.selectedRows[0].dealStatus === 3)) {
        return this.$message.error('此条问题件已回复过')
      }
      if (this.selectedRows.length > 1) {
        for (const item of this.selectedRows) {
          if (item.dealStatus === 1 || item.dealStatus === 3) {
            return this.$message.error('存在已回复的问题件')
          }
        }
      }
      this.isShowReplyDialog = true
    },
    /**
     * 下载模板
     * @param type
     * @returns {Promise<void>}
     */
    async downloadTemplate(type) {
      // 后端接口要求用formdata
      const params = { type }
      const formData = new FormData()
      console.log(type, formData)
      Object.keys(params).forEach((key) => {
        formData.append(key, params[key])
      })
      console.log(type, formData)
      const res = await this.$API_INTER.downloadTemplateNew()
      console.log(res)
      if (res) {
        const enc = new TextDecoder('utf-8')
        let errorData = { code: null }
        try {
          errorData = JSON.parse(enc.decode(new Uint8Array(res))) // 转化成json对象
        } catch (error) {
          // errorData.code = null
        }
        if (errorData.code) {
          this.$message.error(errorData.msg)
        } else {
          if (!!window.ActiveXObject || 'ActiveXObject' in window) {
            // IE
            const name = this.$t('下载模板')
            window.navigator.msSaveOrOpenBlob(res, `${name}${type}.xls`)
          } else {
            // 火狐谷歌都兼容
            const url = window.URL.createObjectURL(new Blob([res], { type: 'application/vnd.ms-excel;charset=utf-8' }))
            const elink = document.createElement('a')
            elink.style.display = 'none'
            elink.href = url
            const name = this.$t('下载模板')
            elink.setAttribute('download', `${name}${type}.xls`)
            document.body.appendChild(elink)
            elink.click()
            URL.revokeObjectURL(elink.href) // 释放URL 对象
            document.body.removeChild(elink)
          }
        }
      }
    },
    /**
     * 选择日期
     */
    selectDate() {
      if (!this.searchParam.date) {
        return
      }
      const [start = '', end = ''] = this.searchParam.date
      this.searchParam.startDate = start
      this.searchParam.endDate = end
    },
    /**
     * 导出数据
     * @returns {Promise<ElMessageComponent>}
     */
    async handleExport() {
      // 处理订单编号
      const { waybillIds, startDate, endDate } = this.searchParam

      // 处理运单编号
      if (waybillIds && waybillIds.length !== 0) {
        if (waybillIds.length > 100) {
          return this.$message.warning(this.$t('请勿超过100条运单'))
        }
      }

      if (this.selectedRows.length <= 0) {
        this.exportLoading = true
        await this.searchFun()
        this.exportLoading = false
        const listTotal = this.page.total || 0
        if (listTotal <= 0) {
          return this.$message.warning(this.$t('没有可导出的数据'))
        }
        if (listTotal > 100000) {
          return this.$message.warning(this.$t('导出数量超过限制'))
        }
      }

      const { current, size } = this.page
      const params = {
        ...this.getParams(),
        moduleName: 'vip_problem_handle',
        current, size,
        startTime: startDate,
        endTime: endDate,
      }
      if (this.selectedRows.length) {
        params.waybillNos = this.selectedRows.map(item => item.waybillNo)
      }
      try {
        this.exportLoading = true
        const res = await this.COM_HTTP.reqExcel(params)
        this.exportLoading = false
        if (res && res.succ) {
          this.$message.success(this.$t('导出成功，请到下载中心查看'))
        } else {
          this.$message.error(this.$t(res.msg))
        }
      } catch (error) {
        console.log(error)
        this.exportLoading = false
      }
    },
    /**
     * 回复成功回调
     */
    async handleReplySuccess(failList) {
      this.loading = true
      // await this.searchFun(1)
      const newParams = Object.assign({ current: this.page.current, size: this.page.size }, this.getParams())
      console.log(newParams, 'newParams')
      const res = await this.COM_HTTP.reqList(newParams)
      // 清除超时定时器
      this.loading = false
      if (res.code === 1) {
        const tableList = res.data.records ? (this.formatList ? this.formatList(res.data) : res.data.records) : []
        this.page.total = res.data.total || 0
        this.page.current = res.data.current || 1
        tableList.forEach((item, index) => {
          failList.forEach((v, k) => {
            if (item.waybillNo === v) {
              item.waybillNoBgRed = true
            }
          })
        })
        this.tableList = tableList
      } else {
        this.$message.error(res.msg)
      }
    },
    renderHeader(h, { column }) {
      return [
        column.label,
        h('el-tooltip', {
          props: {
            placement: 'top'
          }}, [
          h('div', {
            slot: 'content',
            domProps: {
              innerHTML: (() => `${this.$lang('退件中运单不支持预约派送，如需申请请联系客服处理')}`)()
            }}),
          h('i', {
            class: ['el-icon-question'],
            style: {
              fontSize: '12px',
              marginLeft: '4px'
            }
          })
        ]
        )
      ]
    }
  },
}
</script>

<style lang="scss" scoped>
.problem {
  .problem-top {
    padding: 16px 24px;

    .commonSize {
      width: 328px !important;
      height: 32px !important;
    }

    .problem-topLeft {
      margin-top: 10px;
    }
  }

  .table-container {
    padding: 0 24px;
  }
}
.errorData {
  background: rgba(245, 34, 45, 0.5);
  height: 25px;
  cursor: pointer;
  text-align: center;
  color: #fff;
}
</style>
